import styled from 'styled-components';

const ButtonContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.S8};
  padding-top: ${({ theme }) => theme.spacing.S8};
`;

export { ButtonContainer };
